import gql from 'graphql-tag'

export const NAME = 'unlockRegistration'
const UNLOCK_REGISTRATION = gql`
  mutation ${NAME}($id: ID!) {
    ${NAME}(id: $id)
  }
`
export default UNLOCK_REGISTRATION
